import React from 'react';
import './coaText.css';
import logoCOA from "../../Images/coa3.png";
import { Link } from 'react-router-dom';



export default function ButtonE1(){
    return (
        <div className="TextCenter">
             <Link className="TextDecoration" to="/" target="_top"><img className="imgpad2" src={logoCOA} alt="marcafluxo"/></Link>
        
        </div>
    )
}